import { getBlockDefaultClassName } from '@wordpress/blocks';
import { Fragment } from "@wordpress/element";
import { PanelBody, ToggleControl } from "@wordpress/components";
import { InspectorControls, InnerBlocks } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
import './style.scss';

const OneColumn = {
  title: __('One column content'),
  description: __('One column content block for the ABS theme'),
  icon: 'media-text',
  attributes: {
    inverseStyling: {
      type: 'boolean',
      default: false,
    }
  },
  supports: {
    customClassName: false,
  },

  edit: ({ attributes, setAttributes }) => {
    const { inverseStyling } = attributes;
    const toggleInverseStyling = () => {
      setAttributes({ inverseStyling: !inverseStyling });
    };

    // Wrapper-Klasse absichern
    const wrapperClass = [
      'wp-block-abs-content-one-column-block',
      inverseStyling ? 'inverted' : null
    ].filter(Boolean).join(' ');

    return (
      <Fragment>
        <div className={wrapperClass}>
          <div className="container">
            <div className="row">
              <div className="col">
                <InnerBlocks />
              </div>
            </div>
          </div>
        </div>

        <InspectorControls>
          <PanelBody title={ __('Block Style') }>
            <ToggleControl
              label={ __('Invert colors') }
              help={ inverseStyling ? __('Inverted display') : __('Default display') }
              checked={ !!inverseStyling }
              onChange={ toggleInverseStyling }
            />
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    const { inverseStyling } = attributes;

    // Wrapper-Klasse absichern
    const className = [
      getBlockDefaultClassName('abs/content-one-column-block'),
      inverseStyling ? 'inverted' : null
    ].filter(Boolean).join(' ');

    return (
      <div className={className}>
        <div className="container">
          <div className="row">
            <div className="col">
              <InnerBlocks.Content />
            </div>
          </div>
        </div>
      </div>
    );
  },
};

export default OneColumn;
